import { memoize } from 'lodash-es';

import { IHeaderBidder, IPublisher } from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { IMenuList } from '~/src/dash/types/menuList';
export interface IHeaderBidderAdapter {
  key: string;
  text: string;
}

export const multiIndexBidders: string[] = ['apsGuarantee', 'apsOpenAuction', 'apsPMP', 'rokuHB'];

export function getHeaderBidderAdaptersForPublisher(
  sspStr: string,
  showAllBidders: boolean,
  publisher?: IPublisher,
  isSuperUser?: boolean,
  isDashboard?: boolean,
): IHeaderBidderAdapter[] {
  let headerBidderAdapters: IHeaderBidderAdapter[] = [
    { key: 'acuity', text: 'Acuity' },
    { key: 'admixer', text: 'Admixer' },
    { key: 'beachfront', text: 'Beachfront' },
    { key: 'cadent', text: 'Cadent, Aperture MX' },
    { key: 'column6', text: 'Column6' },
    { key: 'publicaCampaign', text: 'Direct Campaign' },
    { key: 'dynamicPlatformConnection', text: 'Dynamic Platform Connection' },
    { key: 'elementaltv', text: 'Elemental TV' },
    { key: 'epsilon', text: 'Epsilon' },
    { key: 'freewheel', text: 'Freewheel' },
    { key: 'freewheelssp', text: 'Freewheel SSP' },
    { key: 'gumgum', text: 'GumGum' },
    { key: 'improvedigital', text: 'Azerion' },
    { key: 'indexExchange', text: 'Index Exchange' },
    { key: 'inmobi', text: 'InMobi' },
    { key: 'iponweb', text: 'The MediaGrid' },
    { key: 'krush', text: 'Krush' },
    { key: 'kubient', text: 'Kubient' },
    { key: 'madhive', text: 'MadHive' },
    { key: 'marketingarchitects', text: 'Marketing Architects' },
    { key: 'magnitectv', text: 'Magnite CTV' },
    { key: 'medianet', text: 'Media.net' },
    { key: 'mobilefuse', text: 'MobileFuse' },
    { key: 'nexstar', text: 'VGI CTV' },
    { key: 'nobid', text: 'NoBid' },
    { key: 'openx', text: 'OpenX' },
    { key: 'origin', text: 'Origin Media' },
    { key: 'platformConnection', text: 'Fixed Price Platform Connection' },
    { key: 'pubmatic', text: 'Pubmatic' },
    { key: 'pulsepoint', text: 'Pulsepoint' },
    { key: 'rubicon', text: 'Rubicon' },
    { key: 'sharethrough', text: 'Sharethrough' },
    { key: 'smaato', text: 'Smaato' },
    { key: 'smart', text: 'SmartRTB' },
    { key: 'smartadserver', text: 'Smart Ad Server' },
    { key: 'smartclip', text: 'SmartClip' },
    { key: 'smartyads', text: 'SmartyAds' },
    { key: 'sonobi', text: 'Sonobi' },
    { key: 'sovrn', text: 'Sovrn' },
    { key: 'spotx', text: 'Spotx' },
    { key: 'stroer', text: 'Stroer' },
    { key: 'synacor', text: 'iMDS' },
    { key: 'teads', text: 'Teads' },
    { key: 'telaria', text: 'Telaria' },
    { key: 'theviewpoint', text: 'TheViewPoint' },
    { key: 'triplelift', text: 'TripleLift' },
    { key: 'trustx', text: 'TrustX' },
    { key: 'undertone', text: 'Undertone' },
    { key: 'rhythmone', text: 'Nexxen CTRL' },
    { key: 'vibe', text: 'Vibe' },
    { key: 'videobyte', text: 'Kargo' },
    { key: 'videoHeroesRevShare', text: 'VideoHeroes Rev Share' },
    { key: 'videoHeroesFixedCPM', text: 'VideoHeroes Fixed CPM' },
    { key: 'vrtcal', text: 'Vrtcal' },
    { key: 'tappx', text: 'TappX' },
    { key: 'appnexus', text: 'Xandr' },
    { key: 'verizon', text: 'Yahoo' },
    { key: 'yieldmo', text: 'Yieldmo' },
    { key: 'zedo', text: 'Zedo' },
  ];
  // some bidder adapters were removed as per CTV-4568

  if (sspStr !== '') {
    const ssp = sspStr.split(',');
    headerBidderAdapters = headerBidderAdapters.filter((hba: IHeaderBidderAdapter) =>
      ssp.includes(hba.key),
    );
  }

  // Add bidders that only appears on some publishers
  // If showAllBidders or isSuperUser is true, push all bidders to headerBidderAdapters

  // Roku HB bidder (Philo, DirectTVStreaming.  Publica/Publica QA for testing)
  if (
    ['381', '804', '1', '760', '518', '716'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    showAllBidders
  ) {
    headerBidderAdapters.push({
      key: 'rokuHB',
      text: 'Roku HB',
    });
  }
  // Magnite bidder (unity only)
  if ((publisher || { ID: '0' }).ID === '558' || isSuperUser || showAllBidders) {
    headerBidderAdapters.push({
      key: 'magnite',
      text: 'Magnite',
    });
  }
  // VAST bidder
  if (
    (publisher || { Reseller: { ID: '0' } }).Reseller &&
    (publisher || { Reseller: { ID: '0' } }).Reseller.ID === '4'
  ) {
    headerBidderAdapters.push({
      key: 'publica',
      text: 'Test Bidder',
    });
  } else {
    headerBidderAdapters.push({
      key: 'publica',
      text: 'Other (VAST tag)',
    });
  }
  // philo, xumo, and super only
  if (
    ['1', '381', '401', '518', '715', '1083'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    showAllBidders
  ) {
    headerBidderAdapters.push({
      key: 'apsOpenAuction',
      text: 'APS Open Auction',
    });
    headerBidderAdapters.push({
      key: 'apsPMP',
      text: 'APS PMP',
    });
    headerBidderAdapters.push({
      key: 'apsGuarantee',
      text: 'APS Guarantee',
    });
  }
  // Pubs with existing consumable bidders and super-users only
  if (
    ['39', '457', '476', '518', '544', '600', '614'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    showAllBidders
  ) {
    headerBidderAdapters.push({
      key: 'consumable',
      text: 'Consumable',
    });
  }
  // Samsung SSP bidder
  if (
    (publisher || { Name: '' }).Name.toLowerCase().includes('samsung') ||
    isSuperUser ||
    showAllBidders
  ) {
    headerBidderAdapters.push(
      {
        key: 'samsungssp',
        text: 'Samsung SSP',
      },
      {
        key: 'samsungssptest',
        text: 'Samsung SSP Test',
      },
    );
  }

  // rokuORTB for DTVS, publica and kenny testing only (or super)
  if (
    ['804', '1', '518'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    showAllBidders
  ) {
    headerBidderAdapters.push({ key: 'rokuORTB', text: 'RokuORTB' });
  }

  // OpenPathEnabled and super users can access TTD
  if (publisher?.OpenPathEnabled === EBool.EBool_TRUE || isSuperUser) {
    headerBidderAdapters.push({
      key: 'thetradedesk',
      text: 'The Trade Desk',
    });
  }

  // user with native vast enabled only
  if (isSuperUser || publisher?.NativeVastEnabled === EBool.EBool_TRUE) {
    headerBidderAdapters.push({
      key: 'nativeVast',
      text: 'Native VAST',
    });
  }

  if (isDashboard) {
    headerBidderAdapters.push({
      key: 'unruly',
      text: 'Nexxen CTRL',
    });
  }

  headerBidderAdapters.sort((a: IHeaderBidderAdapter, b: IHeaderBidderAdapter) =>
    a.text.toUpperCase() > b.text.toUpperCase() ? 1 : -1,
  );
  return headerBidderAdapters;
}

export const unlistedHeaderBidderAdapters: IHeaderBidderAdapter[] = [
  { key: 'unruly', text: 'Nexxen CTRL' },
  { key: 'xandr', text: 'Xandr' },
  { key: 'yahoo', text: 'Verizon Media' },
];

function _headerBidderKeyToLabel(key: string, publisher: IPublisher): string {
  const adapter = getHeaderBidderAdaptersForPublisher('', false, publisher).find(
    (headerBidderAdapter) => headerBidderAdapter.key === key,
  );
  return adapter ? adapter.text : '';
}
export const headerBidderAdapterKeyToLabel = memoize(_headerBidderKeyToLabel);

// make a new Demand Source Menu List and populate with selected bidder codes
export function genBiddersMenuList(
  existingBidderCodes: string[],
  publisher: IPublisher,
  bidders: IHeaderBidder[],
  allowedSSP: string,
  isSuperUser: boolean,
  useBidderFilter?: boolean,
): IMenuList {
  const bidderCodesAsIMenuList: IMenuList = {};
  let _bidderCodes: any[];

  if (useBidderFilter) {
    _bidderCodes = filterHeaderBidderAdaptersFromBidders(publisher, bidders, isSuperUser);
  } else {
    _bidderCodes = getHeaderBidderAdaptersForPublisher('', false, publisher, isSuperUser);
  }

  const sspList = allowedSSP.split(',');
  _bidderCodes
    .sort((a, b) => {
      if (a.key === 'publica') {
        return 1;
      } else if (b.key === 'publica') {
        return -1;
      } else {
        return a.text.localeCompare(b.text);
      }
    })
    .forEach((bidderCode: IHeaderBidderAdapter) => {
      if (allowedSSP === '' || sspList.includes(bidderCode.key)) {
        bidderCodesAsIMenuList[bidderCode.key] = {
          ID: bidderCode.key,
          title: bidderCode.text,
          selected: existingBidderCodes.includes(bidderCode.key),
        };
      }
    });

  return bidderCodesAsIMenuList;
}

// filters bidder adapters to show only those available in bidders passed in AND in headerBidderAdapters
const filterHeaderBidderAdaptersFromBidders = (
  publisher: IPublisher,
  bidders: IHeaderBidder[],
  isSuperUser: boolean,
) => {
  return getHeaderBidderAdaptersForPublisher('', false, publisher, isSuperUser).filter(
    (bidderAdapter: IHeaderBidderAdapter) => {
      return (bidders || []).reduce((ret: boolean, bidder: IHeaderBidder) => {
        // CTV-1470. need this bc console-api changes all verizon Bidder to yahoo
        if (bidder.Bidder === 'yahoo') {
          bidder.Bidder = 'verizon';
        }
        return ret || bidder.Bidder === bidderAdapter.key;
      }, false);
    },
  );
};

// convert IMenuList to comma separated string
export const exportDemandSourceListToString = (demandSourceList: IMenuList) => {
  const selectedDemandSources = [];
  for (const demandSource in demandSourceList) {
    if (demandSourceList[demandSource].selected) {
      selectedDemandSources.push(demandSourceList[demandSource].ID);
    }
  }
  return selectedDemandSources.filter((v) => v.length).join(',');
};
